<template>
	<mw-menu-toolbar
		:title="title"
		:user-data="userData"
		:main-menu-items="mainMenuItems"
		:profile-route="profileRoute"
		:add-logout="addLogout"
		:side-menu-items="sideMenuItems"
		:condensed="condensed"
	>
		<template #navigationDrawer>
			<v-container
				grid-list-xs
				class="text-center"
			>
				<v-row
					wrap
					align-center
				>
					<v-col>
						<v-switch
							v-model="condensed"
							:label="$gettext('Condensed Toolbar')"
							color="primary"
						/>
					</v-col>
				</v-row>
				<v-row v-if="isSimulating">
					<v-col>
						<v-btn
							color="primary"
							variant="outlined"
							@click="StopSimulatingRoles"
						>
							<translate>Stop simulating roles</translate>
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</template>
	</mw-menu-toolbar>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	inform,
} from 'laravel-front-library';
import {
	debounce,
} from 'lodash';

export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		userData: {
			type: Object,
			required: true,
		},
		profileRoute: {
			type: String,
			required: true,
		},
		mainMenuItems: {
			type: Array,
			required: true,
		},
		sideMenuItems: {
			type: Array,
			required: true,
		},
		addLogout: {
			type: Boolean,
			default: false,
		},
		isSimulating: {
			type: Boolean,
			default: false,
		}
	},

	data () {
		return {
			condensed: localStorage.condensedMenu === 'true',
		};
	},

	watch: {
		/**
		 * Watches the condensed value and keeps the localStorage updated with that value
		 *
		 * @param {boolean} newValue - the new value for if we want a condensed value
		 * @returns {void}
		 */
		condensed (newValue) {
			localStorage.condensedMenu = newValue;
		},
	},

	methods: {
		/**
		 * Stop Role simulation
		 *
		 * @returns {void}
		 */
		StopSimulatingRoles () {
			axios.post('/bo/stopsimulating')
				.then(() => {
					inform(this.$gettext('Stopped simulating roles'));
					debounce(() => {
						window.location.reload();
					}, 1000)();
				})
				.catch((error) => {
					window.captureException(error);
				});
		}
	}
};
</script>
<style scoped>
:deep(.v-list-group__items .v-list-item) {
  padding-inline-start: calc(var(--indent-padding)) !important;
}

:deep(.v-list-item__prepend) {
  padding-right: 8px
}
</style>
